export function regionNameFromCode(locale: string, code: string): string {
  const upper = code.trim().toUpperCase()
  if (upper.length !== 2) return code
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(upper) ?? code
  } catch {
    return code
  }
}
